import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { validate } from 'email-validator';
import { signupUser } from '../../actions';

function SignUp(props) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [myName, setMyName] = useState('');
  const [myUsername, setMyUsername] = useState('');
  const [errorMsg, setErrorMsg] = useState('');

  const submit = (e) => {
    console.log(email, password, myName);
    if (!validate(email)) {
      setErrorMsg('Add valid email!');
      return;
    }
    if (password.length < 6) {
      setErrorMsg('Password must be at least 6 characters!');
      return;
    }
    props.signupUser(myName, myUsername, email, password, props.history);
  };

  useEffect(() => {
    setErrorMsg(props.error);
  },
  [props.error]);

  return (
    <div className="sign-in">
      <h1>sign up</h1>
      <form>
        <h2>email</h2>
        <input value={email} onChange={(e) => setEmail(e.target.value)} placeholder="email" />
        <h2>name</h2>
        <input value={myName} onChange={(e) => setMyName(e.target.value)} placeholder="name" />
        <h2>username</h2>
        <input value={myUsername} onChange={(e) => setMyUsername(e.target.value)} placeholder="name" />
        <h2>password</h2>
        <input value={password} onChange={(e) => setPassword(e.target.value)} placeholder="password" type="password" />
        <button type="button" onClick={submit}>Sign Up</button>
        <p className="error-msg">{errorMsg}</p>
      </form>

    </div>
  );
}
const mapStateToProps = (state) => (
  {
    error: state.auth.error,
  }
);
export default withRouter(connect(mapStateToProps, { signupUser })(SignUp));
